<div class="flex h-full flex-col">
  <div class="mt-3 flex grow min-h-0 gap-2">
    <!-- COLLAPSIBLE SIDEBAR WRAPPER -->
    <div *ngIf="items.length" class="sidebar-wrapper h-full" [class.collapsed]="isSidebarCollapsed">
      <!-- TOGGLE BUTTON WITH ARROW ICON -->
      <div class="sidebar-toggle" (click)="toggleSidebar()" [title]="isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'">
        <i class="pi" [class.pi-angle-left]="!isSidebarCollapsed" [class.pi-angle-right]="isSidebarCollapsed"></i>
      </div>
      <!-- SIDEBAR CONTAINER WITH MENU -->
      <div class="sidebar-container h-full">
        <p-panelMenu styleClass="layout-submenu" [model]="items" [multiple]="true"></p-panelMenu>
      </div>
    </div>
    <!-- MAIN CONTENT AREA -->
    <div class="ml-4 flex grow flex-col min-h-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
